import useDropdownOptions from 'hooks/useDropdownOptions';
import { criteriaOptions } from '../utils/subscriptionConsts';

const msgCriteriaPrefix = 'push.api.create.settings.criteria';

export const useCriteria = () => {
    const options = useDropdownOptions(criteriaOptions, msgCriteriaPrefix);
    return options;
};
